import api from './api';

export async function searchJobs(filters = {}) {
	const res = await api.get('/jobs/search', { params: filters });
	return res.data;
}

export async function getJobById(id) {
	const res = await api.get(`/jobs/${id}`);
	return res.data;
}

export async function matchResumeToJobs(resumeId) {
	const res = await api.post('/jobs/match-resume', { resumeId });
	return res.data;
}

export async function getRecommendations() {
	const res = await api.get('/jobs/recommendations');
	return res.data;
}


